import React, { useRef } from "react";

export default function MediumItem({ file, router, csrf_token }) {
  const inputRef = useRef(null);
  console.log(file);

  function copyUrlToClipboard() {
    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(file.url);
    } else {
      inputRef.current.select();
      return new Promise((res, rej) => {
        document.execCommand("copy") ? res() : rej();
      });
    }
  }

  function isImage() {
    const arr = file.url.split(".");
    const ext = arr[arr.length - 1];
    // console.log("ext", ext);
    // console.log(["png, webp, jpg, jpeg"].includes(ext));
    return ["png", "webp", "jpg", "jpeg"].includes(ext);
  }

  return (
    <tr className={ file.isNew ? "success-light" : "grey lighten-3"}>
      <td width="150px">
        <div style={{ maxWidth: "150px" }}>
          {(isImage() && <img className="img-fluid" src={file.url} />) || (
            <i
              className="fas fa-file fs-4 text-muted p-2"
              style={{ fontSize: "32px" }}
            ></i>
          )}
        </div>
      </td>

      <td>
        <div className="media">
          <div className="media-body">
            <p className="mb-0 font-weight-bold">{file.title} </p>
            <div className="d-flex">
              <input
                ref={inputRef}
                className="form-control grey lighten-2 input-alternate mb-0"
                type="text"
                value={file.url}
                readOnly
              />
              <button className="btn" onClick={copyUrlToClipboard}>
                <i className="far fa-clone"></i>
              </button>
            </div>

            <ul className="list-inline mb-0">
              <li className="list-inline-item">
                <a
                  href={router.url("admin.media.edit", { media: file.id })}
                  className="link-color"
                >
                  Edit
                </a>
              </li>

              <li className="list-inline-item">|</li>
              <li className="list-inline-item">
                <a target="_blank" href={file.url} className="link-color">
                  View
                </a>
              </li>

              <li className="list-inline-item">|</li>
              <li className="list-inline-item">
                <form
                  method="POST"
                  action={router.url("admin.media.trash", { media: file.id })}
                  acceptCharset="UTF-8"
                >
                  <input name="_token" type="hidden" value={csrf_token} />
                  <button
                    type="submit"
                    className="btn btn-flat m-0 p-0 link-color waves-effect waves-effect"
                  >
                    Trash
                  </button>
                </form>
              </li>
            </ul>
          </div>
        </div>
      </td>
      <td>
        <div>Last Modified</div>
        <span class="font-small">{file.updated_at}</span>
      </td>
    </tr>
  );
}

// <div className="row my-2">
//   <div className="col-xs-12 col-sm-2 col-md-1">
//     {(isImage() && <img src={file.url} />) || (
//       <i
//         className="fas fa-file fs-4 text-muted p-2"
//         style={{ fontSize: "32px" }}
//       ></i>
//     )}
//   </div>
//   <div className="col">
//     <p className="mb-0 font-weight-bold">{file.filename} </p>

//     <div className="d-flex">
//       <input
//         ref={inputRef}
//         className="form-control"
//         type="text"
//         value={file.url}
//         readOnly
//       />
//       <button className="btn" onClick={copyUrlToClipboard}>
//         <i className="far fa-clone"></i>
//       </button>
//     </div>

//     <ul className="list-inline mb-0">
//       <li className="list-inline-item">
//         <a
//           href={router.url('admin.media.edit', { media: file.id })}
//           className="link-color"
//         >
//           Edit
//         </a>
//       </li>

//       <li className="list-inline-item">|</li>
//       <li className="list-inline-item">
//         <a
//           target="_blank"
//           href={file.url}
//           className="link-color"
//         >
//           View
//         </a>
//       </li>

//       <li className="list-inline-item">|</li>
//       <li className="list-inline-item">
//         <form
//           method="POST"
//           action={router.url('admin.media.trash', { media: file.id })}
//           accept-charset="UTF-8"
//         >
//           <input
//             name="_token"
//             type="hidden"
//             value={file.filename}
//           />
//           <button
//             type="submit"
//             className="btn btn-flat m-0 p-0 link-color waves-effect waves-effect"
//           >
//             Trash
//           </button>
//         </form>
//       </li>
//     </ul>
//   </div>
// </div>

// WEBPACK FOOTER //
// ./resources/js/components/Media/MediumItem.js



// WEBPACK FOOTER //
// ./resources/js/components/Media/MediumItem.js